export const locale = {
  lang: 'ds',
  data: {
    'Tabs': {
      'Offer': 'Tilbud',
      'BasicDetail': 'Grundlæggende detaljer',
      'File': 'Fil',
      'Category': 'Kategori',
      'WorkItem': 'Arbejdspost'
    },
    'TITLE': {
      'CustomerPagination': 'Antal log pr. side',
    },
    'MESSAGE': {
      'Failed': 'Operation mislykket, prøv senere',
      'Success': 'Succes.',
      'CommingSoon': 'Kommer snart..',
      'Deleted': 'Slettet med succes',
      'Added': 'Oprettet med succes',
      'Updated': 'Opdateret med succes',
      'NORECORD': 'Ingen fugt og temperatur fundet',
    },
    'FIELDS':{
      'GoTo':'Gå til',
      'Moisture':'Fugt %',
      'Temperature':'Temperature ℃',
      'SRNO': 'Sr Nr',
      'Status': 'Status',
      'Number': 'Number',
      'Name': 'Name',
      'Createdby': 'Created By',
      'CreatedDate': 'Created Date',
      'ModifyBy': 'Modify By',
      'ModifyDate': 'Modify Date',
      'CoworkerName': 'Coworker',
      'Date': 'Dato',
      'Description': 'Description',
      'Action': 'Action',
      'ModuleName': 'Module',
      'ByCoworker': 'by medarbejder',
      'ByCustomer': 'by customer',
      'All': 'Alle',
      'RoomName': 'Rum Navn',
      'Text': 'Tekst',
      'SelectRoom':'Vælg Rum',
      
    },
    'BUTTONS': {
      'Add': 'Tilføj',
      'Update': 'Opdatering',
      'Cancel': 'Gå tilbage'
    },
    'Headers': {
      'DeleteConformation': 'Vil du slette',
    }
  }
};
